import { getLoadingReducer } from '@disco/state-management/reducers/utility'
import { ROUTER_LOCATION_CHANGE } from '../../../reducers/router'
import reduceReducers from 'reduce-reducers'
import { createReducer } from 'redux-create-reducer'
import * as searchTypes from './types'
import type { PublicPlaylist } from 'types/public-playlist'
import type { Track } from 'types/track'
export type { SearchState } from 'types/shareable-channel'
const initialState = {
  query: null,
  results: [] as (PublicPlaylist | Track)[],
  next: null,
  groupId: null,
  loading: false,
}
const baseReducer = createReducer(initialState, {
  [searchTypes.PUBLIC_SEARCH_SUCCESS](state, { group, response }) {
    return {
      ...state,
      results: response.results,
      next: response.next,
      groupId: group.id,
    }
  },

  [searchTypes.PUBLIC_SEARCH_NEXT_SUCCESS](state, { response }) {
    return {
      ...state,
      results: [...state.results, ...response.results],
      next: response.next,
    }
  },

  [searchTypes.PUBLIC_SEARCH_RESET]() {
    return initialState
  },

  [searchTypes.PUBLIC_SEARCH_UPDATE_QUERY](state, { query }) {
    return {
      ...state,
      query,
      loading: query && query.length > 2 ? true : state.loading || false,
    }
  },

  [ROUTER_LOCATION_CHANGE]() {
    return initialState
  },
})
const loadingReducer = getLoadingReducer(
  initialState,
  (state, action, loaderProps: Record<string, any>) => {
    return { ...baseReducer(state, action), ...loaderProps }
  },
  [
    searchTypes.PUBLIC_SEARCH,
    searchTypes.PUBLIC_SEARCH_SUCCESS,
    searchTypes.PUBLIC_SEARCH_FAIL,
  ],
)
export const searchReducer = reduceReducers(
  baseReducer,
  loadingReducer,
  initialState,
) as any
